/**
 * Shared types for CompositionWizard components
 */
import type { CompositionWizardStep } from "../../../../hooks";
import type { SmartAssetData } from "../SmartAssetCard";
import type { CompositeSmartAsset, CompositionLink } from "../../../../types/valueFlows";

export interface CompositionWizardProps {
  /** All available Smart Assets for composition */
  availableAssets: SmartAssetData[];
  /** Callback when wizard is closed */
  onClose: () => void;
  /** Callback when composite is successfully created */
  onComplete: (composite: CompositeSmartAsset) => void;
}

export interface StepConfig {
  id: CompositionWizardStep;
  label: string;
  description: string;
}

export const STEPS: StepConfig[] = [
  { id: "select", label: "Select Assets", description: "Choose 2+ Smart Assets to compose" },
  { id: "wire", label: "Wire Interfaces", description: "Connect signal and value interfaces" },
  { id: "gates", label: "Configure Gates", description: "Set up disbursement policies (optional)" },
  { id: "preview", label: "Preview", description: "Review composition before creating" },
  { id: "create", label: "Create", description: "Name and generate composite identity" },
];

// Re-export commonly used types
export type { SmartAssetData, CompositeSmartAsset, CompositionLink, CompositionWizardStep };
